import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

export default function TopBarContact() {
  return (
    <div
      className="w-full bg-black text-white"
      style={{ letterSpacing: '0.01em', backgroundColor: '#000' }}
    >
      {/* Desktop Layout */}
      <div className="hidden md:flex flex-row items-center justify-between px-4 py-1 text-xs">
        {/* Left: Phone and Email */}
        <div className="flex flex-row items-center gap-x-4">
          <span className="flex items-center space-x-1">
            <FaEnvelope className="text-green-500 text-sm" />
            <a href="mailto:rajinderbagga@baggainternational.com" className="hover:text-green-400 transition-colors duration-200">
              rajinderbagga@baggainternational.com
            </a>
          </span>
        </div>
        {/* Right: Address */}
        <div className="flex items-center space-x-1">
          <FaMapMarkerAlt className="text-green-500 text-sm" />
          <span>21, Phase -1, HSIIDC, Gurgaon - 122016, Haryana, INDIA</span>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden px-2 py-2">
        <div className="flex flex-col space-y-1 text-[13px]">
          <div className="flex items-center justify-center space-x-1">
            <FaEnvelope className="text-green-500 text-base" />
            <a href="mailto:rajinderbagga@baggainternational.com" className="text-center hover:text-green-400 transition-colors duration-200">
              rajinderbagga@baggainternational.com
            </a>
          </div>
          <div className="flex items-center justify-center space-x-1">
            <FaMapMarkerAlt className="text-green-500 text-base" />
            <span className="text-center">21, Phase -1, HSIIDC, Gurgaon - 122016, Haryana, INDIA</span>
          </div>
        </div>
      </div>
    </div>
  );
}
